const routes = {
    // Don't use customerPaths from here. Use from Constants/Customer/Routes
    appointments: '/my-appointments',
    appointmentsNew: '/my-appointments/new',
    appointmentDetails: (appointmentId) => `/my-appointments/appointment/${appointmentId}`,
    appointmentsMySettings: '/my-appointments/my-settings',
    orderConfirmationEmail: (pathId, orderId) => `/customer/${pathId}/orderconfirmationmail/${orderId}`,
    emailHistory: (emailActionLogId) => `/emailhistory/${emailActionLogId}`,
    search: '/search',
    editSignature: '/edit-signature',
    settings: '/settings/',
    settingsGuidedSelling: '/settings/guided-selling',
    settingsGuidedSellingEdit: (id) => `/settings/guided-selling/edit/${id || ':id'}`,
    settingsEmailTemplates: '/settings/email-templates',
    settingsEmailTemplateEdit: (id) => `/settings/email-template/edit/${id || ':id'}`,
    settingsLeadLists: '/settings/lead-lists',
    internalCustomers: '/internal-customers',
    settingsCustomerInfoTypes: '/settings/customerinfotypes',
    settingsCustomerInfoTypeEdit: (pathId) => `/settings/customerinfotypes/edit/${pathId || ':pathId'}`,
    settingsCompensation: '/settings/compensation',
    settingsCompensationEdit: (id) => `/settings/compensation/edit/${id || ':id'}`,
    settingsQuotationFaq: '/settings/quotationFaq',
    hittaByra: '/settings/hittabyra',
    hittaByraEdit: (id) => `/settings/hittabyra/edit/${id || ':id'}`,
    hittaByraAddDuplicate: (id) => `/settings/hittabyra/addduplicate/${id || ':id'}`,
    hittaPartner: '/settings/hittapartner',
    hittaPartnerEdit: (id) => `/settings/hittapartner/${id || ':id'}`,
    settingsAdminUsers: '/settings/adminusers',
    settingsAdminUsersEdit: (id, type) => `/settings/adminusers/${type || ':type'}/${id || ':id'}`,
    budget: '/settings/budget',
    editBudget: (id, type) => `/settings/editbudget/${id || ':id'}/${type || ':type'}`,
    settingsWorkerJobs: '/settings/worker-jobs',
    settingsFeatureToggles: '/settings/featureflags',
    settingsSystemActionLog: '/settings/system-action-log',
    settingsConfiguration: '/settings/configuration',
    invoicing: '/settings/invoicing',
    logout: '/logout',
    login: '/login',
    leads: '/leads/',
    internalLeads: '/internal-leads',
    aoleadDetails: (leadId) => `/internal-leads/ao-leads/${leadId}`,
    aoleadEdit: (leadId) => `/internal-leads/ao-leads/edit/${leadId}`,
    internalLeadDetails: (leadId) => `/internal-leads/${leadId}`,
    internalLeadEdit: (leadId) => `/internal-leads/edit/${leadId}`,
    leadDetails: (leadId) => `/leads/${leadId}`,
    leadEdit: (leadId) => `/leads/edit/${leadId}`,
    leadsMySettings: '/leads/my-settings',
    myActions: '/my-actions',
    quotation: '/quotation',
    myAppointments: '/my-appointments',
    newCustomerForm: '/new-customer/form',
    newCustomer: '/new-customer',
    status: '/status',
    editCustomerLayout: '/edit-layout',
    myStats: '/mystats',
    productOverview: '/productoverview',
    editProductVersions: '/settings/editproductversions',
    orderApprovalRequests: '/settings/orderapprovalrequests',
    orderApprovalRequestsEdit: (id) => `/settings/orderapprovalrequests/${id || ':id'}`,
    versionArchive: '/version-archive',
    releaseNews: '/settings/release-news',
    releaseNewsEdit: (id) => `/settings/release-news-edit/${id}`,
    eloqua: "/settings/eloqua",
    bokameraadmin: "/settings/bokameraadmin",
    versionArchiveDetails: (versionId) => `/version-archive/${versionId}`,
    customerDirectoryContainer: `/customer-directory/`,
    customerDirectoryContainerEdit: (customerId) => `/customer-directory/${customerId}`,
    createFileBoxTicket: '/createfileboxticket',
    fileBoxTicketDetails: (ticketId) =>  `/filebox/${ticketId || ':ticketId'}`,
    discounts: "/settings/discounts/",
    createNewDiscount: `/settings/discounts/createnewdiscount/`,
    editDiscount: `/settings/discounts/editDiscount/`,
    //Internal Customer Admin routes
    icaTerminationReasons: "/settings/internal-customer-admin/termination-reasons",
    icaTerminationReasonsCreate: "/settings/internal-customer-admin/termination-reasons/create",
    icaTerminationReasonsEdit: `/settings/internal-customer-admin/termination-reasons/edit/`,
    icaLog: "/settings/internal-customer-admin/log",
    vossTargetGroups: "/settings/target-groups",
    vossTargetGroupsCreate: "/settings/target-groups/create",
    vossTargetGroupsEdit: "/settings/target-groups/edit",
    vossPriceAdjustments: "/settings/price-adjustments",
    vossPriceAdjustmentsEdit: "/settings/price-adjustments/edit",
    priceSimulation: "/settings/price-simulation",
    bankruptcyTermination: '/settings/bankruptcy-termination',
    bankruptcyTerminationDetail: (jobId) => `/settings/bankruptcy-termination/${jobId || ':jobId'}`
}

export default routes;